import { setLocalStorageItem, getLocalStorageItem } from 'businesslayer/minutesLocalStore'

// Constants
const TOKEN_RENEWAL_INTERVAL_MINUTES = 25
const TOKEN_RENEWAL_INTERVAL_MS = TOKEN_RENEWAL_INTERVAL_MINUTES * 60 * 1000

// Global variables for token renewal
let renewalInterval: any = null

export const getTemplateServiceToken = async (SSO_AUTHORITY_URL: string, params: any) => {
    try {
        const response = await fetch(SSO_AUTHORITY_URL + `/connect/token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: params
        })
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        setLocalStorageItem('templateToken', data.access_token)
        return data.access_token
    } catch (error) {
        throw error
    }
}

// Function to start token renewal every 25 minutes
export const startTokenRenewal = (SSO_AUTHORITY_URL: string, params: any) => {
    // Clear any existing interval
    if (renewalInterval) {
        clearInterval(renewalInterval)
    }

    // Set up interval for renewal every 25 minutes (25 * 60 * 1000 = 1,500,000 ms)
    renewalInterval = setInterval(async () => {
        try {
            await getTemplateServiceToken(SSO_AUTHORITY_URL, params)
        } catch (error) {
            console.error('❌ [RENEWAL] Failed to renew token:', error)
        }
    }, TOKEN_RENEWAL_INTERVAL_MS) // 25 minutes in milliseconds
}

// Function to stop token renewal
export const stopTokenRenewal = () => {
    if (renewalInterval) {
        clearInterval(renewalInterval)
        renewalInterval = null
    } else {
        console.error('ℹ️ [RENEWAL] No renewal interval to stop')
    }
}

// Function to check if renewal is active
export const isRenewalActive = () => {
    return renewalInterval !== null
}

// Simple monitoring function (optional - for debugging)
let monitoringInterval: any = null

export const startMonitoring = (intervalSeconds = 60) => {
    if (monitoringInterval) {
        return
    }

    monitoringInterval = setInterval(() => {
        const token = getLocalStorageItem('templateToken')
        const renewalActive = isRenewalActive()

        console.error(`🕐 [MONITOR] - Renewal active: ${renewalActive}`)

        if (token) {
            console.error(`🕐 [MONITOR] - Token length: ${token.length}`)
        }
    }, intervalSeconds * 1000)
}

export const stopMonitoring = () => {
    if (monitoringInterval) {
        clearInterval(monitoringInterval)
        monitoringInterval = null
    } else {
        console.error('ℹ️ [MONITOR] No monitoring to stop')
    }
}
